import { Action } from '../../../shared/xs/actions';

export class DefineCo2OffsettingGoalAction implements Action {
  static readonly type = '[co2Offsetting] Define new goal for CO2 offsetting';
}
